import DomainResource from './DomainResource';
import Reference from './types/Reference';
import merge from 'lodash/merge';
import { contactPointTraits } from './trait/contactPointTraits';
import CodeableConcept from '@/fhirworks/types/CodeableConcept';
import Period from '@/fhirworks/types/Period';
import Identifier from '@/fhirworks/types/Identifier';
import ConsentProvision from '@/fhirworks/ConsentProvision';
import Coding from '@/fhirworks/types/Coding';
import ConsentRevoke from '@/fhirworks/ConsentRevoke';

export default class Consent extends DomainResource {
    static __className = 'Consent';

    __objectStructure = {
        identifier: [Identifier],
        status: String, // *required draft | proposed | active | rejected | inactive | entered-in-error
        scope: CodeableConcept, // Which of the four areas this resource covers (extensible)
        policyRule: CodeableConcept,
        category: [CodeableConcept], // Classification of the consent statement - for indexing/retrieval
        patient: Reference, // Who this Consent is for
        dateTime: String, // When this Consent was created or indexed
        provision: ConsentProvision, // Constraints to the base Consent.policyRule

        // first class extension
        period: Period,
        periodOtherReason: String,
        grantor: [Reference],
        grantee: [Reference],
        decision: CodeableConcept,
        disclosureFormat: [Coding],
        substanceAbuse: Boolean,
        substanceAbuseDateTo: String,
        substanceAbuseDateFrom: String,
        substanceAbuseText: String,
        hivTesting: Boolean,
        hivTestingDateTo: String,
        hivTestingDateFrom: String,
        hivTestingText: String,
        reproductiveHealth: Boolean,
        reproductiveHealthDateTo: String,
        reproductiveHealthDateFrom: String,
        reproductiveHealthText: String,
        mentalHealth: Boolean,
        mentalHealthDateTo: String,
        mentalHealthDateFrom: String,
        mentalHealthText: String,
        revoke: ConsentRevoke,
        customExpiration: Boolean,
        preparedBy: Reference,
        questionnaireResponse: Reference,
    };

    constructor(constructJson, className = 'Consent') {
        super(constructJson, className);

        contactPointTraits.call(this);

        this.createAndPopulateStructure(this.__objectStructure, constructJson, this.__objectDefaults);

        // Store server state without default policyRule so PATCH will add it when missing
        this.originalObjJson = merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
        if (!this.originalObjJson.policyRule) {
            this.policyRule = Consent.DEFAULT_POLICY_RULE;
        }
    }

    isExpired() {
        if (!this.period?.end) return true;
        const todayDate = new Date();
        const consentEndDate = new Date(this.period.end);
        return consentEndDate < todayDate;
    }

    // async checkAndUpdateExpirationStatus(dataProvider) {
    //     if (this.status === 'active' && this.isExpired()) {
    //         this.status = 'inactive';
    //         if (dataProvider) {
    //             await dataProvider.save(this);
    //         }
    //     }
    //     return this;
    // }

    // FHIR ppc-1: Either policy or policyRule must be present
    static DEFAULT_POLICY_RULE = {
        coding: [{ system: 'http://terminology.hl7.org/CodeSystem/consentscope', code: 'patient-privacy' }],
        text: 'Release of information consent',
    };

    toJSON() {
        const json = merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
        if (!json.policyRule) {
            json.policyRule = Consent.DEFAULT_POLICY_RULE;
        }
        return json;
    }
}
